import React from 'react';
import kebabCase from 'lodash/kebabCase';
// @ts-ignore
import Button from '@atlaskit/button';
import './additional-help.less';
import { translatableText } from '../../utils/translatable-text';
import track from '../atlas-link/track';

interface AdditionalHelpArgs {
    productName: string;
    deployment: string;
}

const AdditionalHelp: React.FunctionComponent<AdditionalHelpArgs> = (
    props: AdditionalHelpArgs
) => {
    const { productName, deployment } = props;

    return (
        <div data-testid="additional_help" className="additional-help">
            <h2 className="sac-h3">{translatableText.additionalHelp.text}</h2>

            <Button
                className="button"
                onClick={() =>
                    track(
                        `https://community.atlassian.com/t5/custom/page/page-id/create-post-step-1?add-tags=${kebabCase(
                            productName
                        )},${deployment}&from-cac=true`,
                        'Ask the Community',
                        'askTheCommunityButton'
                    )
                }
            >
                <a
                    href={`https://community.atlassian.com/t5/custom/page/page-id/create-post-step-1?add-tags=${kebabCase(
                        productName
                    )},${deployment}&from-cac=true`}
                    rel={'nofollow'}
                    className="link"
                >
                    {translatableText.askTheCommunity.text}
                </a>
            </Button>
        </div>
    );
};

export default AdditionalHelp;
